<div class="color-block-header" [ngClass]="{ 'color-block-header--active': groupTitle === currentGroupTitle }">
  <p class="color-block-header__title">{{ groupTitle }}</p>
  <div
    class="btv-icon-down-arrow"
    [ngClass]="{ 'btv-icon-down-arrow--reverse': groupTitle === currentGroupTitle }"
  ></div>
</div>
